export default {
  module: 'substore',
  description: '',
  steps: [
    {
      name: 'substore.progress_selection',
    },
    {
      name: 'substore.progress_summary',
    },
    {
      name: 'substore.progress_confirmation',
    },
  ],
  active: 'substore.progress_selection',
};
